"use client";

type Props = {
  data: Record<string, any>;
};

export default function JsonLd({ data }: Props) {
  if (!data) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data),
      }}
    />
  );
}
